import { inject, Pipe, PipeTransform } from '@angular/core';
import { RequestParams } from '../models/sys/routing';
import { AppRouterService } from '../services/app-router.service';

@Pipe({ name: 'route' })
export class RoutePipe implements PipeTransform {
  private readonly _appRouter: AppRouterService = inject(AppRouterService);

  /**
   * Format a route & map given parameters
   */
  public transform(value: string, args?: RequestParams): string {
    return this._appRouter.prepareRoute(value, args);
  }
}
